var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padre"},[_c('div',[_c('img',{staticClass:"mb-2 img-fluid",attrs:{"src":_vm.imageHome,"align":"center"}})]),_c('div',[_c('h4',[_vm._v(_vm._s(_vm.phraseHome))])])])}
var staticRenderFns = []

export { render, staticRenderFns }